module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trending"
  }, [_c('div', {
    staticClass: "trending-header"
  }, [_vm._v("\n        Top Stories\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "trending-elements-container"
  }, _vm._l((_vm.articles), function(article) {
    return _c('a', {
      key: article.slug,
      staticClass: "trending-element",
      attrs: {
        "href": _vm.getLink(article.slug)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.openArticle(article.slug)
        }
      }
    }, [_c('div', {
      staticClass: "trending-index"
    }, [_c('intrinsic', {
      attrs: {
        "small": article.media.thumbnail.url,
        "ratio": "square",
        "alt": article.media.thumbnail.alt
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "trending-title"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(article.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tag-slot"
    }, [_c('tags', {
      attrs: {
        "categories": article.categories,
        "size": "small"
      }
    })], 1)])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51d3ccb1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/article/trending.vue
// module id = 176
// module chunks = 4